import React, { Component } from 'react';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import Layout from '../Components/Layout';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import PaginatedItems from "../Components/Pagination";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const badgeStyles = `
.table-container {
    overflow-y: auto !important;
    overflow-x: auto !important;
}
.table-container thead th {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #f8f9fa !important;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
}
.status-dropdown {
    min-width: 160px;
}
.date-dropdown {
    min-width: 140px;
}
.dropdown-toggle::after {
    display: none !important;
}
.dropdown-menu {
    z-index: 1060 !important;
    position: absolute !important;
}
.table tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.02);
}
.action-dropdown .dropdown-menu {
    position: absolute !important;
    z-index: 1070 !important;
    right: 0 !important;
    left: auto !important;
    transform: none !important;
    inset: auto 0px auto auto !important;
}
.action-dropdown {
    position: relative !important;
}
.react-datepicker-popper {
    z-index: 1080 !important;
}
.react-datepicker {
    z-index: 1080 !important;
}
`;

export class Estimate extends Component {
    state = {
        records: [],
        historyId: null,
        search: "",
        statusFilter: 'Estimate',
        workflowStatusFilter: 'All Statuses',
        movingEstimateId: null,
        dateFilter: 'All Dates',
        estimateFilter: 'All Estimates',
        filtered: false,
        pageNumber: 1,
        totalItems: 0,
        perPage: parseInt(localStorage.getItem('estimatePerPage')) || 25,
        showDeleteModal: false,
        deleteEstimateId: null,
        loading: true,
        error: null,
        showCustomDatePicker: false,
        customStartDate: null,
        customEndDate: null,
        showHistoryModal: false,
        historyData: [],
        historyRfqId: null,
        historyPage: 1,
        historyTotalPages: 1,
        historyLoading: false
    }

    componentDidMount() {
        this.getEstimates(1);
    }


    getEstimates(pageNumber = 1) {
        let _self = this;

        // Set loading state
        _self.setState({ loading: true, error: null });

        let dataObj = {
            skip: (pageNumber - 1) * _self.state.perPage,
            limit: _self.state.perPage,
            status_filter: _self.state.statusFilter !== "All" ? _self.state.statusFilter : null,
            workflow_status_filter: _self.state.workflowStatusFilter !== "All Statuses" ? _self.state.workflowStatusFilter : null,
            search: _self.state.search || null
        }

        // Add date filter parameters
        if (_self.state.dateFilter !== "All Dates") {
            dataObj.date_filter = _self.state.dateFilter;

            // Add custom date range if selected
            if (_self.state.dateFilter === 'Custom' && _self.state.customStartDate && _self.state.customEndDate) {
                dataObj.custom_start_date = _self.state.customStartDate.toISOString().split('T')[0];
                dataObj.custom_end_date = _self.state.customEndDate.toISOString().split('T')[0];
            }
        }

        if(_self.state.search !== "" || _self.state.statusFilter !== "All" || _self.state.workflowStatusFilter !== "All Statuses" || _self.state.dateFilter !== "All Dates") {
            const filtered = true;
            _self.setState({ filtered });
        } else {
            const filtered = false;
            _self.setState({ filtered });
        }

        // Call the API to get estimates
        const params = new URLSearchParams();
        Object.keys(dataObj).forEach(key => {
            if (dataObj[key] !== null && dataObj[key] !== undefined) {
                params.append(key, dataObj[key]);
            }
        });

        axios.get(`/api/estimates?${params}`)
            .then(response => {
                console.log('API Response:', response.data);

                if (response.data && response.data.success) {
                    const estimates = response.data.data || [];
                    console.log('Estimates from API:', estimates);

                    // Transform API data to match component format
                    const records = estimates
                        .filter(estimate => {
                            // Apply status filtering logic
                            const isArchived = estimate.is_archived === true || estimate.is_archived === 1;

                            // If filtering by "All", show everything (both estimates and archived)
                            if (_self.state.statusFilter === 'All') {
                                return true;
                            }

                            // If filtering by "Estimate", only show non-archived estimates
                            if (_self.state.statusFilter === 'Estimate') {
                                return !isArchived;
                            }

                            // If filtering by "Archived", only show archived estimates
                            if (_self.state.statusFilter === 'Archived') {
                                return isArchived;
                            }

                            return true;
                        })
                        .map((estimate, index) => {
                            // Format timestamps
                            let dateCreated = 'N/A';
                            if (estimate.date_created) {
                                dateCreated = new Date(estimate.date_created).toLocaleDateString();
                            }

                            // Check if archived
                            const isArchived = estimate.is_archived === true || estimate.is_archived === 1;
                            const status = isArchived ? 'archived' : (estimate.status || 'draft');

                            const transformedRecord = {
                                id: estimate.estimate_id,
                                formula: estimate.formula_id || estimate.formula || '—',
                                customer: estimate.customer || '—',
                                product_name: estimate.product_name,
                                form: estimate.form,
                                status: status,
                                tier1Cost: estimate.tier1_cost || 0,
                                tier2Cost: estimate.tier2_cost || 0,
                                tier3Cost: estimate.tier3_cost || 0,
                                dateCreated: dateCreated,
                                rfqStatus: estimate.rfq_status || estimate.RfqStatus
                            };

                            return transformedRecord;
                        });

                    console.log('All transformed records:', records);

                    _self.setState({
                        records,
                        totalItems: response.data.total || 0,
                        loading: false,
                        error: null
                    });
                } else {
                    console.log('API returned success: false or no response.data');
                    console.log('Full response:', response);
                    _self.setState({
                        records: [],
                        totalItems: 0,
                        loading: false,
                        error: 'Failed to load estimates'
                    });
                }
            }).catch(error => {
            console.error('There was an error fetching estimates!', error);
            _self.setState({
                records: [],
                totalItems: 0,
                loading: false,
                error: 'Error fetching estimates'
            });
        });
    }

    onSearchClick(e) {
        this.setState({ pageNumber: 1 }, () => {
            this.getEstimates(1);
        });
    }

    onSearch(e) {
        const search = e.target.value;
        this.setState({ search });
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.setState({ pageNumber: 1 }, () => {
                this.getEstimates(1);
            });
        }, 300);
    }

    componentWillUnmount() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
    }

    onKeyUp(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.onSearchClick(e);
        }
    }

    handleStatusFilter = (status) => {
        this.setState({ statusFilter: status, pageNumber: 1 }, () => {
            this.getEstimates(1);
        });
    }

    handleWorkflowStatusFilter = (workflowStatus) => {
        this.setState({ workflowStatusFilter: workflowStatus, pageNumber: 1 }, () => {
            this.getEstimates(1);
        });
    }

    handleDateFilter = (dateFilter) => {
        if (dateFilter === 'Custom') {
            this.setState({ dateFilter, showCustomDatePicker: true });
        } else {
            this.setState({ dateFilter, pageNumber: 1, showCustomDatePicker: false }, () => {
                this.getEstimates(1);
            });
        }
    }

    handleCustomDateApply = () => {
        if (this.state.customStartDate && this.state.customEndDate) {
            this.setState({ showCustomDatePicker: false, pageNumber: 1 }, () => {
                this.getEstimates(1);
            });
        } else {
            toast.error('Please select both start and end dates');
        }
    }

    handleCustomDateCancel = () => {
        this.setState({
            showCustomDatePicker: false,
            dateFilter: 'All Dates',
            customStartDate: null,
            customEndDate: null
        });
    }

    handleEstimateFilter = (estimateFilter) => {
        this.setState({ estimateFilter, pageNumber: 1 }, () => {
            this.getEstimates(1);
        });
    }

    openPage(e, estimateId, mode = 'edit') {
        e.preventDefault();
        // Extract numeric part from estimate ID (e.g., "EST-0006" -> "6")
        const numericId = estimateId.replace(/^EST-0*/, '');
        const modeParam = mode === 'view' ? '&mode=view' : '';
        window.location.href = "/estimate/edit?id=" + numericId + modeParam;
    }


    paginatePage = (page) => {
        const pageNumber = page
        this.setState({ pageNumber });
        this.getEstimates(page);
    }

    onPerPageChange(e) {
        const perPage = parseInt(e.target.value);
        localStorage.setItem('estimatePerPage', perPage);
        this.setState({ perPage, pageNumber: 1 }, () => {
            this.getEstimates(1);
        });
    }

    handleAction = (action, estimateId) => {
        switch(action) {
            case 'view':
                this.openPage({ preventDefault: () => {} }, estimateId, 'view');
                break;
            case 'history':
                this.showEstimateHistory(estimateId);
                break;
            case 'archive':
                this.archiveEstimate(estimateId);
                break;
            case 'unarchive':
                this.unarchiveEstimate(estimateId);
                break;
            case 'delete':
                this.setState({ showDeleteModal: true, deleteEstimateId: estimateId });
                break;
            default:
                break;
        }
    }

    showEstimateHistory = (estimateId) => {
        // Extract numeric ID from formatted ID
        const numericId = parseInt(estimateId.replace('EST-', ''));
        this.openHistoryModal(numericId);
    }

    openHistoryModal = (rfqId) => {
        this.setState({
            showHistoryModal: true,
            historyRfqId: rfqId,
            historyPage: 1
        }, () => {
            this.fetchHistory(1);
        });
    }

    closeHistoryModal = () => {
        this.setState({
            showHistoryModal: false,
            historyData: [],
            historyRfqId: null,
            historyPage: 1
        });
    }

    fetchHistory = async (page) => {
        const { historyRfqId } = this.state;
        this.setState({ historyLoading: true });

        try {
            const response = await axios.get(`/rfq/${historyRfqId}/history`, {
                params: { page, per_page: 10 }
            });

            if (response.data.success) {
                this.setState({
                    historyData: response.data.data,
                    historyPage: page,
                    historyTotalPages: response.data.pagination.totalPages,
                    historyLoading: false
                });
            }
        } catch (error) {
            console.error('Error fetching history:', error);
            toast.error('Failed to load history');
            this.setState({ historyLoading: false });
        }
    }

    handleHistoryPageChange = (newPage) => {
        this.fetchHistory(newPage);
    }

    viewHistoryRecord = (rfqHistoryId) => {
        // TODO: Implement view historical RFQ data
        toast.info(`Viewing history record ${rfqHistoryId}`);
    }

    archiveEstimate = async (estimateId) => {
        try {
            await axios.put(`/api/estimates/${estimateId}/archive`);
            toast.success(`${estimateId} archived successfully`);
            this.getEstimates(this.state.pageNumber);
        } catch (error) {
            console.error('Error archiving estimate:', error);
            toast.error(`Failed to archive ${estimateId}`);
        }
    }

    unarchiveEstimate = async (estimateId) => {
        try {
            await axios.put(`/api/estimates/${estimateId}/unarchive`);
            toast.success(`${estimateId} unarchived successfully`);
            this.getEstimates(this.state.pageNumber);
        } catch (error) {
            console.error('Error unarchiving estimate:', error);
            toast.error(`Failed to unarchive ${estimateId}`);
        }
    }

    confirmDelete = async () => {
        const { deleteEstimateId } = this.state;
        try {
            await axios.delete(`/api/estimates/${deleteEstimateId}`);

            // Refresh the list after successful deletion
            this.getEstimates(this.state.pageNumber);

            this.setState({
                showDeleteModal: false,
                deleteEstimateId: null
            });
            toast.success(`${deleteEstimateId} deleted successfully`);
        } catch (error) {
            console.error('Error deleting estimate:', error);
            toast.error(`Failed to delete ${deleteEstimateId}`);
        }
    }

    handleCloseDeleteModal = () => {
        this.setState({ showDeleteModal: false, deleteEstimateId: null });
    }

    handleMoveTo = async (estimateId, targetStatus) => {
        const numericId = parseInt(estimateId.replace('EST-', ''));
        this.setState({ movingEstimateId: estimateId });

        const statusNames = {
            2: 'Formula : R&D',
            3: 'Estimate - Purch. Review',
            4: 'Estimate - Acct. Mgmt. Review',
            5: 'Estimate - Mgmt. Review',
        };

        try {
            await axios.put(`/rfq/${numericId}/status`, { status: targetStatus });
            toast.success(`Moved to ${statusNames[targetStatus] || 'target stage'} successfully`);
            this.getEstimates(this.state.pageNumber);
        } catch (error) {
            console.error('Error moving estimate:', error);
            const detail = error.response?.data?.detail || 'Failed to move record';
            toast.error(detail);
        } finally {
            this.setState({ movingEstimateId: null });
        }
    }

    getStatusBadge = (status) => {
        const badgeStyles = {
            'draft': { backgroundColor: '#6c757d', color: 'white' },
            'in-process': { backgroundColor: '#ffc107', color: 'black' },
            'review': { backgroundColor: '#17a2b8', color: 'white' },
            'archived': { backgroundColor: '#dc3545', color: 'white' },
        };

        const displayText = {
            'draft': 'Draft',
            'in-process': 'InProcess',
            'review': 'Review',
            'archived': 'Archived',
        };

        return (
            <span
                style={{
                    ...badgeStyles[status],
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: '500',
                }}
            >
                {displayText[status] || status}
            </span>
        );
    };

    render() {
        const { records, search, statusFilter, workflowStatusFilter, dateFilter, estimateFilter, pageNumber, totalItems, perPage, showDeleteModal, deleteEstimateId, loading, error, showCustomDatePicker, customStartDate, customEndDate } = this.state;

        console.log('Render - records:', records);
        console.log('Render - records.length:', records.length);
        console.log('Render - loading:', loading);

        return (
            <Layout>
                <style>{badgeStyles}</style>
                <div style={{ height: 'calc(100vh - 70px)', display: 'flex', flexDirection: 'column', paddingTop: '20px', overflow: 'hidden' }}>
                    <section className="section pb-0" style={{ marginBottom: '0px', paddingTop: '20px', paddingBottom: '0px', flex: '1', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <div className="container-fluid" style={{ paddingLeft: '24px', flex: '1', display: 'flex', flexDirection: 'column', minHeight: 0 }}>

                            {/* Header Section */}
                            <div className="d-flex justify-content-between align-items-center mb-3" style={{ flexShrink: 0 }}>
                                <div>
                                    <p style={{ color: '#6b7280', fontSize: '16px', margin: 0 }}>Manage and track all formula estimates</p>
                                </div>
                            </div>

                            {/* Filters Section */}
                            <div className="row" style={{'@media print': {display: 'none'}, flexShrink: 0}}>
                                <div className="col-lg-12 mb-3">
                                    <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '20px' }}>
                                        <h5 style={{ fontWeight: '600', marginBottom: '16px' }}>Filters & Search</h5>
                                        <div className="row">
                                            <div className="col-lg-6 mb-3">
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onKeyDown={(e) => this.onKeyUp(e)}
                                                        onChange={(e) => this.onSearch(e)}
                                                        placeholder="Search by estimate number, customer, or product..."
                                                        value={search}
                                                        style={{padding: '12px'}}
                                                        aria-describedby="basic-addon2"
                                                    />
                                                    <div className="input-group-append">
                                                        <span onClick={(e) => this.onSearchClick(e)} className="input-group-text ti-search" id="basic-addon2" style={{cursor: 'pointer'}}></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-3 mb-3">
                                                <Dropdown className="w-100">
                                                    <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start d-flex justify-content-between align-items-center status-dropdown">
                                                        {statusFilter}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="w-100">
                                                        <Dropdown.Item
                                                            onClick={() => this.handleStatusFilter('All')}
                                                            active={statusFilter === 'All'}
                                                        >
                                                            {statusFilter === 'All' && <i className="ti-check me-2"></i>}
                                                            All
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleStatusFilter('Estimate')}>
                                                            {statusFilter === 'Estimate' && <i className="ti-check me-2"></i>}
                                                            Estimate
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleStatusFilter('Archived')}>
                                                            {statusFilter === 'Archived' && <i className="ti-check me-2"></i>}
                                                            Archived
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                            <div className="col-lg-3 mb-3">
                                                <Dropdown className="w-100">
                                                    <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start d-flex justify-content-between align-items-center date-dropdown">
                                                        {dateFilter === 'Custom' && this.state.customStartDate && this.state.customEndDate ?
                                                            `${this.state.customStartDate.toLocaleDateString()} - ${this.state.customEndDate.toLocaleDateString()}` :
                                                            dateFilter
                                                        }
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="w-100">
                                                        <Dropdown.Item
                                                            onClick={() => this.handleDateFilter('All Dates')}
                                                            active={dateFilter === 'All Dates'}
                                                        >
                                                            {dateFilter === 'All Dates' && <i className="ti-check me-2"></i>}
                                                            All Dates
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleDateFilter('Today')}>
                                                            {dateFilter === 'Today' && <i className="ti-check me-2"></i>}
                                                            Today
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleDateFilter('This Week')}>
                                                            {dateFilter === 'This Week' && <i className="ti-check me-2"></i>}
                                                            This Week
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleDateFilter('This Month')}>
                                                            {dateFilter === 'This Month' && <i className="ti-check me-2"></i>}
                                                            This Month
                                                        </Dropdown.Item>
                                                        <Dropdown.Divider />
                                                        <Dropdown.Item onClick={() => this.handleDateFilter('Custom')}>
                                                            {dateFilter === 'Custom' && <i className="ti-check me-2"></i>}
                                                            Custom Date Range
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Estimate List Section */}
                            <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column', flex: '1', minHeight: 0, marginBottom:'10px' }}>
                                <div style={{ padding: '24px', borderBottom: '1px solid #e5e7eb', flexShrink: 0 }}>
                                    <h5 style={{ fontWeight: '600', margin: 0 }}>Estimate List ({totalItems} items)</h5>
                                </div>

                                <div className="table-container" style={{ flex: '1', minHeight: 0 }}>
                                    <table className="table table-hover mb-0">
                                        <thead style={{ background: '#f8f9fa' }}>
                                            <tr>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Estimate ID</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Customer</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Product Name</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Form</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center' }}>Status</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Date Created</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4">
                                                        <div className="d-flex justify-content-center align-items-center" style={{ gap: '10px' }}>
                                                            <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                                                            <span>Loading estimates...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : error ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4 text-danger">
                                                        <i className="ti-alert-circle me-2"></i>
                                                        {error}
                                                    </td>
                                                </tr>
                                            ) : records.length > 0 ? (
                                                records.map((estimate, index) => (
                                                    <tr key={index} style={{ borderTop: index > 0 ? '1px solid #f3f4f6' : 'none' }}>
                                                        <td style={{ padding: '16px 24px', border: 'none', fontWeight: '600' }}>
                                                            <a href="#" onClick={(e) => this.openPage(e, estimate.id)} style={{ color: '#007bff', textDecoration: 'none' }}>
                                                                {estimate.id}
                                                            </a>
                                                        </td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>{estimate.customer || '-'}</td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>{estimate.product_name || '-'}</td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>{estimate.form || '-'}</td>
                                                        <td style={{ padding: '16px 24px', border: 'none', textAlign: 'center' }}>
                                                            <span className={`badge ${
                                                                estimate.status === 'draft' ? 'bg-secondary' :
                                                                estimate.status === 'in-process' ? 'bg-warning' :
                                                                estimate.status === 'review' ? 'bg-info' :
                                                                estimate.status === 'archived' ? 'bg-dark' : 'bg-secondary'
                                                            }`} style={{ padding: '6px 12px' }}>
                                                                {estimate.status === 'draft' ? 'Draft' :
                                                                 estimate.status === 'in-process' ? 'InProcess' :
                                                                 estimate.status === 'review' ? 'Review' :
                                                                 estimate.status === 'archived' ? 'Archived' : estimate.status}
                                                            </span>
                                                        </td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>{estimate.dateCreated}</td>
                                                        <td style={{ padding: '16px 24px', border: 'none', textAlign: 'center' }}>
                                                            <Dropdown className="action-dropdown">
                                                                <Dropdown.Toggle
                                                                    as="button"
                                                                    className="btn btn-link text-dark p-0 border-0"
                                                                    id={`dropdown-${estimate.id}`}
                                                                    style={{ fontSize: '20px', background: 'none', boxShadow: 'none', cursor: 'pointer', textDecoration: 'none' }}
                                                                >
                                                                    <i className="ti-more"></i>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu align="end" style={{ zIndex: 1060, position: 'absolute' }}>
                                                                    <Dropdown.Item onClick={() => this.handleAction('view', estimate.id)} style={{ padding: '8px 16px' }}>
                                                                        <i className="ti-eye" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                        <span>View</span>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item onClick={() => this.handleAction('history', estimate.id)} style={{ padding: '8px 16px' }}>
                                                                        <i className="ti-time" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                        <span>History</span>
                                                                    </Dropdown.Item>
                                                                    {estimate.status !== 'archived' && (
                                                                        <>
                                                                            <Dropdown.Divider />
                                                                            <Dropdown.Header style={{ fontSize: '11px', textTransform: 'uppercase', color: '#6c757d' }}>Move To</Dropdown.Header>
                                                                            <Dropdown.Item
                                                                                onClick={() => this.handleMoveTo(estimate.id, 2)}
                                                                                style={{ padding: '6px 16px', fontSize: '13px' }}
                                                                                disabled={this.state.movingEstimateId === estimate.id}
                                                                            >
                                                                                <span>Formula : R&D</span>
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Item
                                                                                onClick={() => this.handleMoveTo(estimate.id, 3)}
                                                                                style={{ padding: '6px 16px', fontSize: '13px' }}
                                                                                disabled={this.state.movingEstimateId === estimate.id}
                                                                            >
                                                                                <span>Estimate - Purch. Review</span>
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Item
                                                                                onClick={() => this.handleMoveTo(estimate.id, 4)}
                                                                                style={{ padding: '6px 16px', fontSize: '13px' }}
                                                                                disabled={this.state.movingEstimateId === estimate.id}
                                                                            >
                                                                                <span>Estimate - Acct. Mgmt. Review</span>
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Item
                                                                                onClick={() => this.handleMoveTo(estimate.id, 5)}
                                                                                style={{ padding: '6px 16px', fontSize: '13px' }}
                                                                                disabled={this.state.movingEstimateId === estimate.id}
                                                                            >
                                                                                <span>Estimate - Mgmt. Review</span>
                                                                            </Dropdown.Item>
                                                                            <Dropdown.Divider />
                                                                        </>
                                                                    )}
                                                                    {estimate.status === 'archived' ? (
                                                                        <Dropdown.Item onClick={() => this.handleAction('unarchive', estimate.id)} style={{ padding: '8px 16px' }}>
                                                                            <i className="ti-archive" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                            <span>Unarchive</span>
                                                                        </Dropdown.Item>
                                                                    ) : (
                                                                        <Dropdown.Item onClick={() => this.handleAction('archive', estimate.id)} style={{ padding: '8px 16px' }}>
                                                                            <i className="ti-archive" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                            <span>Archive</span>
                                                                        </Dropdown.Item>
                                                                    )}
                                                                    <Dropdown.Divider />
                                                                    <Dropdown.Item
                                                                        className="text-danger"
                                                                        onClick={() => this.handleAction('delete', estimate.id)}
                                                                        style={{ padding: '8px 16px' }}
                                                                    >
                                                                        <i className="ti-trash" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                        <span>Delete</span>
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7" className="text-center py-4 text-muted">
                                                        No estimates found matching your criteria
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {totalItems > perPage && (
                                    <div style={{ padding: '16px 24px', borderTop: '1px solid #e5e7eb', flexShrink: 0 }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                <span>Show</span>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={perPage}
                                                    onChange={(e) => this.onPerPageChange(e)}
                                                    style={{ width: 'auto' }}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                                <span>entries</span>
                                            </div>
                                            <PaginatedItems
                                                itemsPerPage={perPage}
                                                totalItems={totalItems}
                                                paginate={this.paginatePage}
                                                currentPage={pageNumber}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                </div>

                {/* Custom Date Range Modal */}
                <Modal show={showCustomDatePicker} onHide={this.handleCustomDateCancel}>
                    <Modal.Header closeButton>
                        <Modal.Title>Select Custom Date Range</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Start Date</label>
                                <DatePicker
                                    selected={customStartDate}
                                    onChange={(date) => this.setState({ customStartDate: date })}
                                    maxDate={customEndDate || new Date()}
                                    className="form-control"
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="Select start date"
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">End Date</label>
                                <DatePicker
                                    selected={customEndDate}
                                    onChange={(date) => this.setState({ customEndDate: date })}
                                    minDate={customStartDate}
                                    maxDate={new Date()}
                                    className="form-control"
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="Select end date"
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCustomDateCancel}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.handleCustomDateApply}
                            disabled={!customStartDate || !customEndDate}
                        >
                            Apply
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={showDeleteModal} onHide={this.handleCloseDeleteModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete estimate <strong>{deleteEstimateId}</strong>? This action cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseDeleteModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={this.confirmDelete}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* History Modal */}
                <Modal show={this.state.showHistoryModal} onHide={this.closeHistoryModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>RFQ History - RFQ-{String(this.state.historyRfqId).padStart(4, '0')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.historyLoading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden"> </span>
                                </div>
                            </div>
                        ) : this.state.historyData.length === 0 ? (
                            <div className="text-center py-4 text-muted">
                                No history records found
                            </div>
                        ) : (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Updated On</th>
                                                <th>Updated By</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.historyData.map((record) => (
                                                <tr key={record.rfqHistoryId}>
                                                    <td>{new Date(record.updatedOn).toLocaleString()}</td>
                                                    <td>{record.updatedBy}</td>
                                                    <td>
                                                        <span className={`badge ${
                                                            record.status === 'Draft' ? 'bg-secondary' :
                                                            record.status === 'In-Process' ? 'bg-primary' :
                                                            record.status === 'Submitted to Formulation' ? 'bg-success' :
                                                            record.status === 'Archived' ? 'bg-dark' : 'bg-warning'
                                                        }`}>
                                                            {record.status}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={() => this.viewHistoryRecord(record.rfqHistoryId)}
                                                        >
                                                            <i className="ti-eye"></i> View
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {this.state.historyTotalPages > 1 && (
                                    <div className="d-flex justify-content-center align-items-center mt-3">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={() => this.handleHistoryPageChange(this.state.historyPage - 1)}
                                            disabled={this.state.historyPage === 1}
                                            className="me-2"
                                        >
                                            <i className="ti-angle-left"></i> Previous
                                        </Button>
                                        <span className="mx-3">
                                            Page {this.state.historyPage} of {this.state.historyTotalPages}
                                        </span>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={() => this.handleHistoryPageChange(this.state.historyPage + 1)}
                                            disabled={this.state.historyPage === this.state.historyTotalPages}
                                            className="ms-2"
                                        >
                                            Next <i className="ti-angle-right"></i>
                                        </Button>
                                    </div>
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeHistoryModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                <ToastContainer />
            </Layout>
        );
    }
}

export default Estimate;